:host([scale="s"]) {
  @apply text-n2 h-6;
  --calcite-chip-spacing-s-internal: theme("spacing[1]");
  --calcite-chip-spacing-l-internal: theme("spacing[2]");
  .close,
  .select-icon--active {
    @apply h-4 w-4;
  }

  .image-container {
    @apply h-5 w-5;
  }

  .container.is-circle {
    @apply w-6 h-6;
  }
}

:host([scale="m"]) {
  @apply text-n1 h-8;
  --calcite-chip-spacing-s-internal: theme("spacing[1.5]");
  --calcite-chip-spacing-l-internal: theme("spacing[2]");

  .close,
  .image-container,
  .select-icon--active {
    @apply h-6 w-6;
  }

  .container.is-circle {
    @apply w-8 h-8;
  }
}

:host([scale="l"]) {
  @apply text-0 h-11;
  --calcite-chip-spacing-s-internal: theme("spacing[2]");
  --calcite-chip-spacing-l-internal: theme("spacing[3]");
  .image-container,
  .close,
  .select-icon--active {
    @apply h-8 w-8;
  }

  .container.is-circle {
    @apply w-11 h-11;
  }
}

:host {
  @apply inline-flex
    cursor-default
    rounded-full;
}

.container {
  @apply inline-flex
  h-full
  max-w-full
  items-center
  rounded-full
  focus-base
  justify-center
  border
  border-solid
  border-color-1
  box-border
  font-medium;
  &:not(.is-circle) {
    padding-inline: var(--calcite-chip-spacing-s-internal);
  }
  &.selectable {
    @apply cursor-pointer;
  }
  &:not(.non-interactive):focus {
    @apply focus-outset;
  }
}

:host([scale="s"]) .container.image--slotted {
  padding-inline-start: calc(theme("spacing[0.5]") / 2);
}

:host([scale="s"]) .container.is-circle {
  padding-inline: 0;
}

.container.text--slotted .title {
  @apply truncate;
  padding-inline: var(--calcite-chip-spacing-s-internal);
}

.container:not(.text--slotted) .title {
  display: none;
}

.container:not(.image--slotted) .image-container {
  display: none;
}

.container.closable {
  padding-inline-end: calc(var(--calcite-chip-spacing-l-internal) / 2);
}

.container:not(.is-circle) {
  &.image--slotted {
    padding-inline-start: calc(var(--calcite-chip-spacing-l-internal) / 2);
  }

  &.image--slotted .image-container {
    margin-inline-end: var(--calcite-chip-spacing-s-internal);
  }

  &.image--slotted .image-container ~ .chip-icon {
    margin-inline-start: var(--calcite-chip-spacing-s-internal);
  }

  &.selectable:not(.text--slotted) .chip-icon {
    margin-inline-end: var(--calcite-chip-spacing-s-internal);
  }

  &:not(.selectable):not(.text--slotted) .chip-icon {
    margin-inline-start: var(--calcite-chip-spacing-s-internal);
  }

  &:not(.text--slotted) .chip-icon {
    margin-inline-end: var(--calcite-chip-spacing-s-internal);
  }

  &:not(.text-slotted).image--slotted .image-container {
    margin-inline-end: var(--calcite-chip-spacing-s-internal);
  }

  &:not(.closable):not(.text--slotted).image--slotted.selectable .image-container {
    margin-inline-end: 0;
    ~ .chip-icon {
      margin-inline-start: calc(var(--calcite-chip-spacing-s-internal) * 2);
    }
  }
}

.chip-icon {
  @apply relative my-0 inline-flex duration-150 ease-in-out;
  margin-inline: var(--calcite-chip-spacing-s-internal);
}

.image-container {
  @apply inline-flex overflow-hidden;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.close {
  @apply focus-base
    transition-default
    text-color-1
    m-0
    cursor-pointer
    items-center
    border-none
    bg-transparent;
  -webkit-appearance: none;
  display: flex;
  border-radius: 50%;
  align-content: center;
  justify-content: center;
  --calcite-chip-transparent-hover: var(--calcite-color-transparent-hover);
  --calcite-chip-transparent-press: var(--calcite-color-transparent-press);
  &:hover {
    background-color: var(--calcite-chip-transparent-hover);
  }
  &:focus {
    background-color: var(--calcite-chip-transparent-hover);
    @apply focus-inset;
  }
  &:active {
    background-color: var(--calcite-chip-transparent-press);
  }
  & calcite-icon {
    color: inherit;
  }
}

.select-icon {
  align-self: center;
  justify-content: center;
  align-items: center;
  display: flex;
  inset-block-start: -1px;
  position: relative;
  visibility: hidden;
  inline-size: 0;
  opacity: 0;
  transition:
    opacity 0.15s ease-in-out,
    inline-size 0.15s ease-in-out;
  &.select-icon--active {
    visibility: visible;
    opacity: 0.5;
  }
}
.container:not(.is-circle).image--slotted .select-icon.select-icon--active {
  margin-inline-end: var(--calcite-chip-spacing-s-internal);
}

:host([selected]) .select-icon {
  opacity: 1;
}

.container:hover .select-icon--active {
  opacity: 1;
}

slot[name="image"]::slotted(*) {
  @apply rounded-half flex h-full w-full overflow-hidden;
}

:host([kind="neutral"]) {
  background-color: var(--calcite-color-foreground-2);
  color: var(--calcite-color-text-1);
  .container {
    border-color: transparent;
  }
  .close {
    color: var(--calcite-color-text-3);
  }
  .chip-icon {
    color: var(--calcite-ui-icon-color, var(--calcite-color-text-3));
  }
}

:host([kind="inverse"]) {
  background-color: var(--calcite-color-inverse);
  @apply text-color-inverse;
  .container {
    border-color: transparent;
  }
  .close {
    @apply text-color-inverse;
  }
  .chip-icon {
    color: var(--calcite-ui-icon-color, var(--calcite-color-text-inverse));
  }
}

:host([kind="brand"]) {
  background-color: var(--calcite-color-brand);
  color: var(--calcite-color-text-inverse);
  .container {
    border-color: transparent;
  }
  .close {
    @apply text-color-inverse;
  }
  .chip-icon {
    color: var(--calcite-ui-icon-color, var(--calcite-color-text-inverse));
  }
}

:host([appearance="outline-fill"]),
:host([appearance="outline"]) {
  @apply text-color-1 bg-foreground-1;
  .close {
    @apply text-color-3;
  }
  .chip-icon {
    color: var(--calcite-ui-icon-color, var(--calcite-color-text-3));
  }
}

:host([appearance="outline-fill"]) {
  @apply bg-foreground-1;
}

:host([appearance="outline"]) {
  @apply bg-transparent;
}

:host([kind="neutral"][appearance="outline-fill"]) .container,
:host([kind="neutral"][appearance="outline"]) .container {
  border-color: var(--calcite-color-border-1);
}

:host([kind="inverse"][appearance="outline-fill"]) .container,
:host([kind="inverse"][appearance="outline"]) .container {
  border-color: var(--calcite-color-border-inverse);
}

:host([kind="brand"][appearance="outline-fill"]) .container,
:host([kind="brand"][appearance="outline"]) .container {
  border-color: var(--calcite-color-brand);
}

:host([kind="brand"][appearance="solid"]),
:host([kind="inverse"][appearance="solid"]) {
  button {
    outline-color: var(--calcite-color-text-inverse);
  }
}

:host([closed]) {
  display: none;
}

@include disabled();
@include base-component();
